import { render, staticRenderFns } from "./detailEditModal.vue?vue&type=template&id=507dc2e6&scoped=true&"
import script from "./detailEditModal.vue?vue&type=script&lang=js&"
export * from "./detailEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507dc2e6",
  null
  
)

export default component.exports